export const SIGNIN_START = 'SIGNIN_START'
export const SIGNIN_ERROR = 'SIGNIN_ERROR'
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const REQUEST_RESET_PASSWORD_START = 'REQUEST_RESET_PASSWORD_START'
export const REQUEST_RESET_PASSWORD_SUCCESS = 'REQUEST_RESET_PASSWORD_SUCCESS'
export const REQUEST_RESET_PASSWORD_ERROR = 'REQUEST_RESET_PASSWORD_ERROR'
export const RESET_PASSWORD_START = 'RESET_PASSWORD_START'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
export const TOKEN_RENEWAL = 'TOKEN_RENEWAL'
export const TOKEN_RENEWAL_START = 'TOKEN_RENEWAL_START'
export const TOKEN_RENEWAL_SUCCESS = 'TOKEN_RENEWAL_SUCCESS'
export const TOKEN_RENEWAL_ERROR = 'TOKEN_RENEWAL_ERROR'
